// extracted by mini-css-extract-plugin
export default {"mainPanel":"MainPage_mainPanel__Y9A+g","withoutHeader":"MainPage_withoutHeader__pmq6D","withHeader":"MainPage_withHeader__3PI+0"};